/**
 * A near-silent WAV played inside the user's tap on mobile so WebKit authorises
 * the persistent media element before the real chapter URL is known. Shared so
 * anything watching the element can tell the primer apart from audiobook audio.
 */
export const DEFERRED_PLAYBACK_PRIMER_SRC =
  'data:audio/wav;base64,UklGRigAAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQQAAACAgICA';
